import { createContext } from "react";

import type { AuthApi, AuthState, Credentials, LoginStep, Permission, Session } from "./types";

export interface AuthContextValue {
  state: AuthState;
  /** The signed-in session (also while "expired", so screens keep rendering under the prompt). */
  session: Session | null;
  /** The identity-service boundary (login steps, password, sessions). */
  api: AuthApi;
  /** Step 1 of the login; a `session` step signs in right away, other steps are for the page. */
  signIn(credentials: Credentials): Promise<LoginStep>;
  /** Finish a multi-step login (after TOTP, enrolment or a forced password change). */
  acceptSession(session: Session): void;
  signOut(): Promise<void>;
  can(permission: Permission): boolean;
  /** Latest access token (for fetch wrappers created outside React render). */
  getAccessToken(): string | null;
  /** Refresh now (single flight); resolves the new token or `null` (→ state "expired"). */
  refreshNow(): Promise<string | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
